module.exports = __webpack_public_path__ + "ptc_momoro_S1.b1e06de1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_S1.jpg
// module id = E72e
// module chunks = 0